import { Avatar, theme } from 'antd'
import { observer } from 'mobx-react-lite'

import { userManager } from '@/Core/Managers'
import { initials } from '@/Ship/Helpers/fieldViews'

const text = (value: unknown): string => (typeof value === 'string' ? value.trim() : '')

/**
 * Ім'я того, хто увійшов, так, як його пише блок користувача: «Прізвище Ім'я»
 * — порядок легасі (`UserInfo/index.jsx:63`, `SPEC-014` §1.2). Ініціали
 * аватара беруться з того самого рядка: «Ткаченко Ірина» → «ТІ».
 */
export const currentUserName = (user: Record<string, unknown>): string =>
    [user['lastName'], user['firstName']].map(text).filter(Boolean).join(' ') || text(user['shortName'])

/**
 * Аватар того, хто увійшов: фото або ініціали.
 *
 * Observer над `userManager.user`: профіль після завантаження чи видалення
 * фото кладе туди відповідь бека, і аватар у шапці міняється одразу, без
 * перезавантаження (С2.1, D-29 — у легасі фото зникало до наступного `/me`).
 *
 * Фото — приватний файл (ADR 042): `url` — підписане посилання з терміном
 * дії. Якщо воно вже не відкривається, antd показує ініціали замість
 * порожнього кола.
 */
export const CurrentUserAvatar = observer(({ size = 28 }: { size?: number }) => {
    const { token } = theme.useToken()
    const user = userManager.user

    const photo = user['photo'] as { url?: unknown } | null | undefined
    const photoUrl = typeof photo?.url === 'string' && photo.url !== '' ? photo.url : undefined
    const name = currentUserName(user)

    return (
        <Avatar
            size={size}
            {...(photoUrl ? { src: photoUrl } : {})}
            alt={name || 'Користувач'}
            style={{ background: token.colorPrimaryBg, color: token.colorPrimary, fontSize: Math.round(size * 0.4) }}
        >
            {initials(name) || '?'}
        </Avatar>
    )
})
